import {useTranslation} from "next-i18next";
import React, {useEffect, useState} from "react";
import {ChecklistItem} from "./Checklist";

interface CheckboxProps {
	item: ChecklistItem;
	onChange: (checked: boolean, id: number | string) => void;
	mobileVersion?: boolean;
	onCountChange?: (itemId: string | number, count: number) => void;
	maxPersonCount?: number;
	extraSpace?: boolean;
}

function Checkbox(props: CheckboxProps) {
	const [checked, setChecked] = useState(
		props.item.defaultChecked ?? props.item.checked ?? false
	);
	const {t} = useTranslation();
	// useEffect(() => {
	//   // if (typeof props.item !== "string" && props.item.checked) {
	//   //   setChecked(props.item.checked);
	//   // }
	// }, []);

	useEffect(() => {
		if (props.item.checked != undefined) setChecked(props.item.checked);
	}, [props.item.checked]);
	return (
		<div
			className={`select-none relative py-1 pl-8 ${
				typeof props.item !== "string" && props.item.tertiaryLabel
					? "pr-0"
					: "pr-4"
			} cursor-pointer ${props.mobileVersion && "h-14 flex items-center"}`}
			onClick={() => {
				const nextChecked = !(props.item.checked ?? checked);
				setChecked(nextChecked);
				props.onChange(nextChecked, props.item.id);
			}}
		>
			{!props.item.customLabel && (
				<div className="flex flex-row items-center justify-start gap-x-2">
					<div className={`flex flex-row items-center`}>
						{(props.extraSpace && props.item.count == null) && <div className="w-20"></div>}
						{props.item.count != null && (
							<div className={`flex flex-row items-center justify-center gap-x-2 ${props.extraSpace && "w-20"}`}>
								<button
									disabled={!checked}
									type="button"
									className="w-6 h-6 rounded-full bg-leo-bg-gray flex items-center justify-center"
									onClick={(e) => {
										e.stopPropagation();
										if (props.item.count) {
											props.onCountChange &&
											props.onCountChange(
												props.item.id,
												props.item.count - 1
											);
										}
									}}
								>
                  <span
	                  className={`text-leo-button-gray text-2xl font-bold ${
		                  checked ? "opacity-100" : "opacity-40"
	                  }`}
                  >
                    -
                  </span>
								</button>
								<span
									className={`text-leo-button-gray text-base md:text-lg ${
										checked ? "opacity-100" : "opacity-40"
									}`}
								>
                  {props.item.count}
                </span>
								<button
									// disabled={!checked}
									type="button"
									className="w-6 h-6 rounded-full bg-leo-bg-gray flex items-center justify-center"
									onClick={(e) => {
										e.stopPropagation();
										//props.item.count < props.maxPersonCount!
										if (props.item.count != null) {
											props.onCountChange &&
											props.onCountChange(
												props.item.id,
												props.item.count + 1
											);
										}
									}}
								>
                  <span className="text-leo-button-gray text-2xl font-bold">
                    +
                  </span>
								</button>
							</div>
						)}
					</div>
					<div className="flex justify-between items-center gap-x-2 w-full">
            <span className={`block`}>
              <p className="text-black text-base md:text-lg">
                {t(props.item.primaryLabel!)}{" "}
	              <span className="text-leo-text-gray italic text-base md:text-lg">
                  {props.item.secondaryLabel}
                </span>
              </p>
            </span>
						{props.item.tertiaryLabel && checked && (
							<p className="font-bold text-leo-divider-gray whitespace-nowrap text-base md:text-lg">
								{t(props.item.tertiaryLabel)} {t("consts.currency")}
							</p>
						)}
					</div>
				</div>
			)}
			{props.item.customLabel && props.item.customLabel}

			<span className={`absolute inset-y-0 left-0 flex pt-3`}>
        <input
	        type="checkbox"
	        readOnly
	        className="checkbox"
	        checked={props.item.checked ?? checked}
        />
      </span>
		</div>
	);
}

export default Checkbox;
